var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Preloader'),_c('div',[_c('Landing'),_c('About'),_c('Portofolio'),_c('Projects'),_c('Contact'),_c('Footer'),_c('socialLink')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }